import script from "./NovelEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelEditor.vue?vue&type=script&setup=true&lang=js"

import "./NovelEditor.vue?vue&type=style&index=0&id=1013f3aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1013f3aa"]])

export default __exports__